export default __webpack_public_path__ + "static/media/right_trees.966b8a6a.svg";